import { SearchItemOperator } from '@Types/api/common/filters';
import { Mapper } from '@Features/utils/prepareSearchCriterias';
import { TypeDict } from '@Types/index';
import { transformBooleanLabelToValue } from '@Utils/transformToOptions';

import { FilterForm } from './types';

export const initialValuesFilterForm: FilterForm = {
  dateFrom: '',
  dateTo: '',
  leaveTypes: [],
  statuses: [],
  totDays: '',
  ticketReimbursementRequired: [],
  passportRequired: [],
  homeCountryContactNumber: '',
  replacementEmployeeNumber: '',
};

export const filterTypes: Record<
  keyof typeof initialValuesFilterForm,
  SearchItemOperator
> = {
  dateFrom: 'ge',
  dateTo: 'le',
  leaveTypes: 'in',
  statuses: 'in',
  totDays: 'eq',
  ticketReimbursementRequired: 'in',
  passportRequired: 'in',
  homeCountryContactNumber: 'like',
  replacementEmployeeNumber: 'like',
};

export const getFiltersMapper =
  (leaveTypes: TypeDict[], statuses: TypeDict[]): Mapper =>
  (key, value) => {
    if (key === 'dateFrom') {
      return ['startDate', value];
    }

    if (key === 'dateTo') {
      return ['endDate', value];
    }

    if (key === 'leaveTypes') {
      const leaveTypeResultValue = (value as string[]).map(
        (item) =>
          leaveTypes.find((leaveType) => leaveType.codeDesc === item)!.codeNum
      );
      return ['leaveTypeID', leaveTypeResultValue];
    }

    if (key === 'totDays') {
      return ['totDays', Number(value)];
    }

    if (key === 'ticketReimbursementRequired') {
      const resultValue = (value as string[]).map(transformBooleanLabelToValue);
      return ['ticketRequired', resultValue];
    }

    if (key === 'passportRequired') {
      const resultValue = (value as string[]).map(transformBooleanLabelToValue);
      return ['passportRequired', resultValue];
    }

    if (key === 'homeCountryContactNumber') {
      return ['telephone', value];
    }

    if (key === 'replacementEmployeeNumber') {
      return ['replacementEmpNo', value];
    }

    const statusResultValue = (value as string[]).map(
      (item) => statuses.find((status) => status.codeDesc === item)!.codeNum
    );
    return ['reqStatusId', statusResultValue];
  };
